export const COOKIE_PREFERENCES_STORAGE_KEY = "oxy-cookie-preferences";
export const OPEN_COOKIE_PREFERENCES_EVENT = "oxy:open-cookie-preferences";

export function openCookiePreferences() {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new Event(OPEN_COOKIE_PREFERENCES_EVENT));
}
